import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './_components/Layout';
import { AuthProvider } from './_providers/AuthProvider';
import { ModalProvider } from './_providers/ModalProvider';
import { PlanProvider } from './_providers/PlanProvider';
import routing from './routing';
import { LangProvider } from './_providers/LangProvider';

function App() {
  return (
    <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <Navigate to="/en" />
                }
              />
              <Route
                path="/:lang/*"
                element={
                  <LangProvider>
      <AuthProvider>
        <PlanProvider>
          <ModalProvider>
                  <Layout>
                    <Routes>
                      {routing.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={<route.component />}
                        />
                      ))}
                    </Routes>
                  </Layout>
                  </ModalProvider>
        </PlanProvider>
      </AuthProvider>
      </LangProvider>
                }
              />
            </Routes>

    </BrowserRouter>
  );
}

export default App;
